import React from "react";
import { Location } from "@navigation";
import { CustomerContractEditor } from "../CustomerContractEditor/CustomerContractEditor";

export class CreateCustomerContractLocation extends Location<{}> {
  constructor() {
    super({});
  }

  render() {
    return <CustomerContractEditor id={null} />;
  }

  toURI(): string {
    return "customer_contracts/create";
  }
}
